import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { NotificationTasksProvider } from './context/NotificationTasksProvider'
import { NotificationTasksMain } from './components/NotificationTasksMain'

export const HighnoteNotificationTasks = () => {
  return (
    <NuqsAdapter>
      <NotificationTasksProvider>
        <NotificationTasksMain />
      </NotificationTasksProvider>
    </NuqsAdapter>
  )
}
